
export const tickers = "/public/v1/tickers";
export const tickersQuotes = "/public/v1/tickers/quotes";
export const plans = "/api/v2/payment/plans";

export const originUrl = process.env.REACT_APP_Origin || window.location.origin;
export const bourseviewApiUrl = process.env.REACT_APP_Bourseview_Api || 'https://api.bourseview.com';